import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent, IonLabel } from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00030 } from '../../../../P00030';
import { P00032 } from '../../../../P00032';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { P0003600DureeAjustementLoiEau } from '../../../Enum/P0003600DureeAjustementLoiEau';
import { P0003600TypeFonctionHorsGelEnum } from '../../../Enum/P0003600TypeFonctionHorsGelEnum';
import { P0003600CapteurTemperatureEnum } from '../../../Enum/P0003600CapteurTemperatureEnum';
import { P0003600SeuilTemperatureHorsGel } from '../../../Enum/P0003600SeuilTemperatureHorsGel';
import { AffichageWarningComponent } from '../../../../../../../../components/ecosystems/affichage-warning/affichage-warning.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';

@Component({
  selector:
    'app-p0003600-filtration-mise-en-oeuvre-fonctionnalites-prevention-gel',
  templateUrl:
    './p0003600-filtration-mise-en-oeuvre-fonctionnalites-prevention-gel.component.html',
  styleUrls: [
    './p0003600-filtration-mise-en-oeuvre-fonctionnalites-prevention-gel.component.scss',
  ],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    TranslatePipe,
    IonLabel,
    LabelConfigurationComponent,
    AffichageWarningComponent,
    LabelDescriptionComponent,
  ],
})
export class P0003600FiltrationMiseEnOeuvreFonctionnalitesPreventionGelComponent
  implements OnInit
{
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  hasProduitP00030() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00030()) ?? 0;
  }

  hasProduitP00032() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00032()) ?? 0;
  }

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P0003600DureeAjustementLoiEau =
    P0003600DureeAjustementLoiEau;
  protected readonly P0003600TypeFonctionHorsGelEnum =
    P0003600TypeFonctionHorsGelEnum;
  protected readonly P0003600CapteurTemperatureEnum =
    P0003600CapteurTemperatureEnum;
  protected readonly P0003600SeuilTemperatureHorsGel =
    P0003600SeuilTemperatureHorsGel;
}
